import * as React from 'react'
import { type SVGAttributes } from 'react'

import * as bcorp from './BCorp'
import * as ulule from './Ulule'

type SvgSpritesheetProps = SVGAttributes<SVGElement>

export function SvgSpritesheet({
  xmlns = 'http://www.w3.org/2000/svg',
  ...props
}: SvgSpritesheetProps): React.ReactElement<SvgSpritesheetProps> {
  return (
    <svg xmlns={xmlns} {...props}>
      <defs>
        <bcorp.LogoSymbol />
        <ulule.HorizontalLogoSymbol />
        <ulule.OwlOnlyLogoSymbol />
      </defs>
    </svg>
  )
}
